module.exports = __webpack_public_path__ + "img/index_icon.82bf956a.png";